module.exports = __webpack_public_path__ + "static/assets/a345981b050eca24c3b561e09419de15.png";